export const SSO_STORAGE_KEYS = {
  CACHE: 'ma-sso-cache',
  TRANSACTION: 'ma-sso-transaction',
  TOKENS: 'ma-sso-tokens',
  TEST: 'ma-sso-storage-manager-test', // Used for validating that a storage-manager interface is accessible at runtime
} satisfies Record<string, `ma-sso-${string}`>;

export const SSO_CACHE_KEYS = {
  OIDC_CONFIGURATION: 'oidc-configuration',
} as const;

export const SSO_TRANSACTION_KEYS = {
  PKCE: 'pkce-verifier',
  STATE: 'oauth-state',
  NONCE: 'openid-nonce',
  ORIGINAL_URI: 'original-uri',
} as const;

export const SSO_TOKEN_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  ID_TOKEN: 'idToken',
  REFRESH_TOKEN: 'refreshToken',
  PENDING_REMOVAL: 'pendingRemoval',
  ISSUER: 'issuer',
  SCOPES: 'scopes',
  TOKEN_USE: 'tokenUse',
} as const;

export const STORAGE_COOKIE_EXPIRATION = 365 * 24 * 60 * 60 * 1000; // 1 year
